import type { ReactElement } from 'react'
import { Navigate, Outlet } from 'react-router'

import { useMe } from '@/auth/queries'

export function ParentRoute(): ReactElement {
  const me = useMe()

  if (me.isPending) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        role="status"
        aria-label="Checking your session"
      >
        <div className="border-muted-foreground/30 border-t-foreground h-8 w-8 animate-spin rounded-full border-4" />
      </div>
    )
  }

  if (me.isError || !me.data) {
    return <Navigate to="/login" replace />
  }

  if (me.data.role === 'admin') {
    return <Navigate to="/admin/families" replace />
  }

  return <Outlet />
}
